import * as req from 'api/actions';
import * as c from './constant';

export const getSeniorCitizenList = (
  payload = { module_type: 'SENIOR' },
  callback
) =>
  req.list(
    c.GET_SENIOR_CITIZEN,
    'api/v1/administrators/senior_citizen_imports',
    payload,
    callback
  );

  export const showSeniorCitizentList = (id, payload, callback) =>
  req.item(
    c.SHOW_SENIOR_CITIZEN,
    `api/v1/administrators/senior_citizen_imports/${id}`,
    payload,
    callback
  );

  export const showSeniorCitizen = (id, payload, callback) =>
  req.item(
    c.SHOW_SENIOR_CITIZEN,
    `api/v1/administrators/senior_citizen_imports/${id}`,
    payload,
    callback
  );

  export const approveTransaction = (id, payload, callback) =>
  req.update(
    c.APPROVE_TRANSACTION,
    
    `api/v1/administrators/senior_citizen_imports/${id}`,
    payload,
    callback,
    res => {
      const { message } = res.res;
      alert.success(message || 'Successfully Updated !');
      if (callback) callback();
    }
  );

  export const rejectTransaction = (id, payload, callback) =>
  req.update(
    c.REJECT_TRANSACTION,
    `api/v1/administrators/senior_citizen_imports/${id}`,
    payload,
    callback,
    res => {
      const { message } = res.res;
      alert.success(message || 'Successfully Updated !');
      if (callback) callback();
    }
  );

  export const clearSeniorCitizen = () => req.setList(c.SHOW_SENIOR_CITIZEN, []);

export const getIncidentList = (
  payload = { module_type: 'EHELP' },
  callback
) =>
  req.list(
    c.GET_INCIDENT,
    'api/v1/administrators/ehelp/incident_reports',
    payload,
    callback
  );

export const showIncidentList = (id, payload, callback) =>
req.item(
  c.SHOW_INCIDENT,
  `api/v1/administrators/ehelp/incident_reports/${id}`,
  payload,
  callback
);

export const clearIncident = () => req.setList(c.SHOW_INCIDENT, []);